import moment from 'moment'
import 'moment/locale/tr';
import React from "react";
import {user} from "./Utils"
import {DateTime} from "luxon";

moment.locale('en');

export const toRelativeTimeString = (value) => {
    if (!value)
        return '';
    const language = (localStorage.getItem('i18nextLng') || 'en').split('-')[0];
    return moment(value).locale(language).fromNow();
}

// Humanized, locale-aware length of a span given in milliseconds ("25 minutes",
// "2 saat"). Deliberately coarse -- it backs "finishes in about X" estimates,
// where a rounded figure reads better than an exact one.
export const toHumanizedDuration = (milliseconds) => {
    const language = (localStorage.getItem('i18nextLng') || 'en').split('-')[0];
    return moment.duration(milliseconds).locale(language).humanize();
}

export const isOlderThanDays = (value, days) => {
    return !value || moment().diff(moment(value), 'days') > days;
}


export const getWeeksAgo = (number) => {
    let today = new Date();
    return new Date(today.setDate(today.getDate()-7*number));
}


export const getWeekNumber = (value) => {
    return DateTime.fromJSDate(new Date(value)).weekNumber;
}


export const getFirstDayOfTheYear = () => {
    let today = new Date();
    return new Date(today.getFullYear(), 0, 1);
}

export const getMonthsAgoFirstDay = (number) => {
    let today = new Date();
    return new Date(today.getFullYear(), today.getMonth()-number, 1);
}

export const getMonthsAgoFirstDayOfDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth()-1, 1);
}

export const getMonthsAgoLastDayOfDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth()+1, 0);
}

export const getNextMonthFirstDayOfDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth()+1, 1);
}

export const getNextMonthLastDayOfDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth()+1, 0);
}

export const getMonthsAgo = (number) => {
    let today = new Date();
    return new Date(today.setMonth(today.getMonth()-number));
}

export const getYearsAgo = (number) => {
    let today = new Date();
    return new Date(today.setFullYear(today.getFullYear()-number));
}

export const toDateTimeString = (value) =>
{
    if(value && user() && user().timezone)
    {
        let m = moment(value);
        return m.tz(user().timezone).format("YYYY-MM-DD HH:mm:ss");
    }
    else
        return "";
};

export const toDateString = (value) =>
{

    if(value && user() && user().timezone)
    {
        if (value instanceof Date) {
            return DateTime.fromJSDate(value).setZone(user().timezone).toFormat('yyyy-MM-dd');
        }
        else if (value.toString().includes("T") ) {
            return DateTime.fromISO(value).setZone(user().timezone).toFormat('yyyy-MM-dd');
        }
        else {
            return DateTime.fromMillis(value).setZone(user().timezone).toFormat('yyyy-MM-dd');
        }
        // let m = moment(value);
        // return m.tz(user().timezone).format("YYYY-MM-DD");
    }
    else
        return "";
};

export const toDateStringIgnoringTimezone = (value) =>
{
    if(value && user() && user().timezone)
    {
        let m = moment(value);
        return m.format("YYYY-MM-DD");
    }
    else
        return "";
};

export const getDateString = (d, separator='-') => {
    let newDate = new Date(d);
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date<10?`0${date}`:`${date}`}`;
}


export const getCurrentDate = (separator='-') =>
{
    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
}

export const getTimeZoneDisplay = (timezone) =>{
    return "(GMT" + moment.tz(timezone).format('Z') + ") " + timezone;
};


// ---- Recurring schedule time helpers (UTC <-> local) --------------------
// Schedule rows store hour/minute in UTC. Users edit in their local (browser)
// timezone. These convert a row between {hour:'HH:MM'} (UTC) and {hh,mm} (local),
// shifting weekday(s) when the time crosses midnight. Non-weekday sentinels in
// job_days (e.g. 7 = "Never") are preserved as-is.
const pad2 = (n) => String(n === null || n === undefined ? 0 : n).padStart(2, '0');

// local = UTC + offset (minutes)
export const localOffsetMinutes = () => -new Date().getTimezoneOffset();

// Short label like "UTC+3" / "UTC-4:30" for the current local timezone.
export const localTzLabel = () => {
    const off = localOffsetMinutes();
    const sign = off < 0 ? '-' : '+';
    const abs = Math.abs(off);
    const h = Math.floor(abs / 60), m = abs % 60;
    return 'UTC' + sign + h + (m ? ':' + pad2(m) : '');
};

const shiftScheduleDays = (days, off) => (days || [])
    .map(d => (d >= 0 && d <= 6) ? (((d + off) % 7 + 7) % 7) : d);

export const scheduleRowToLocal = (row) => {
    const [h, m] = String(row.hour || '0:0').split(':').map(x => parseInt(x, 10) || 0);
    let total = h * 60 + m + localOffsetMinutes();
    let off = 0;
    while (total < 0) { total += 1440; off -= 1; }
    while (total >= 1440) { total -= 1440; off += 1; }
    return {...row, hh: Math.floor(total / 60), mm: total % 60, job_days: shiftScheduleDays(row.job_days, off)};
};

export const scheduleRowToUtc = (row) => {
    let total = row.hh * 60 + row.mm - localOffsetMinutes();
    let off = 0;
    while (total < 0) { total += 1440; off -= 1; }
    while (total >= 1440) { total -= 1440; off += 1; }
    const out = {...row, hour: pad2(Math.floor(total / 60)) + ':' + pad2(total % 60), job_days: shiftScheduleDays(row.job_days, off)};
    delete out.hh; delete out.mm;
    return out;
};
